export default __webpack_public_path__ + "static/media/TBM-Planner-1.8775089b.png";